
  <a class="btn-scroll-top show animate__animated animate__fadeIn"  matTooltip="Ir arriba" *ngIf="gotoToogle$==true" (click)="goTo()">
    <i class="btn-scroll-top-icon fas fa-chevron-up"></i>
  </a>

